import i18n from 'services/base/i18n';

export default {
  outbound: () => i18n.pgettext('Enums|Directions', 'Outbound'),
  inbound:  () => i18n.pgettext('Enums|Directions', 'Inbound'),
  local:    () => i18n.pgettext('Enums|Directions', 'Local'),
  unknown:  () => i18n.pgettext('Enums|Directions', 'Unknown'),
};
